import { pubsub, cart } from '@services';
import { notyf } from '@modules';

class ProductForm extends HTMLElement {
  #unsubscribers = [];
  #form = this.querySelector('form[id^="product-form-"]');
  #quantityInput = this.#form?.querySelector('input[name="quantity"]');
  // Get all submit buttons that are part of the form
  #submitButtons = document.querySelectorAll(`button[form="${this.#form?.getAttribute('id')}"]`);

  connectedCallback() {
    this.#form?.addEventListener('submit', (event) => this.#onFormSubmit(event));

    this.#unsubscribers.push(
      pubsub.subscribe('variant:change', ({ id, data: { html } }) => {
        if (id !== this.dataset.productId) return;
        const productForm = html.querySelector('product-form').cloneNode(true);
        this.replaceWith(productForm);
      }),
      pubsub.subscribe('quantity:change', ({ quantity }) => {
        this.#quantityInput.value = quantity;
      })
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Handle form submission
   * @param {Event} event
   */
  async #onFormSubmit(event) {
    event.preventDefault();
    this.#toggleLoading(true);

    try {
      await cart.add({ form: this.#form });
    } catch (error) {
      this.#onError(error);
    } finally {
      this.#toggleLoading(false);
    }
  }

  /**
   * Toggle loading state on submit buttons
   * @param {boolean} loading
   */
  #toggleLoading(loading) {
    this.#submitButtons?.forEach((button) => button.classList.toggle('loading', loading));
  }

  /**
   * Handle form error
   * @param {Error} error - The error object
   */
  #onError({ message }) {
    notyf.error(message);
  }
}

customElements.define('product-form', ProductForm);
